const MonthlySupporters = [
  {
    name: 'Jeet Mandaliya',
    github: 'sereneinserenade',
    linkedin: 'https://www.linkedin.com/in/sereneinserenade/',
    profile:
      'https://media-exp2.licdn.com/dms/image/C4D03AQFZVBxbVij6ag/profile-displayphoto-shrink_400_400/0/1654029236729?e=1663200000&v=beta&t=gJw40CDGo5S5m3z0GEUB2Cnu5UsspjkdthwmPPVzokE',
  },
];

const YearlySupporters = [];

export { MonthlySupporters, YearlySupporters };
